import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/industries/RealestateConstructionIndustries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Partials/DynamicPortfolio.tsx");
